/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorNewsletterSignup from 'sites/allas/components/labrador/NewsletterSignup';

export const DynamicLabradorNewsletterSignup: typeof LabradorNewsletterSignup = (props) => {
    return <ErrorBoundary><LabradorNewsletterSignup {...props} /></ErrorBoundary>;
}
export type DynamicLabradorNewsletterSignupProps = PropsFromComponent<typeof LabradorNewsletterSignup>;
